/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Label } from "./Label";
import { LabelFromJSON, LabelFromJSONTyped, LabelToJSON } from "./Label";

export interface LabelListResponse {
  offset: number;
  limit: number;
  order: string;
  sort: string;
  count: number | null;
  data: Array<Label>;
}

export function LabelListResponseFromJSON(json: any): LabelListResponse {
  return LabelListResponseFromJSONTyped(json);
}

export function LabelListResponseFromJSONTyped(json: any): LabelListResponse {
  if (json == null) {
    return json;
  }

  return {
    offset: json["offset"],
    limit: json["limit"],
    order: json["order"],
    sort: json["sort"],
    count: json["count"],
    data: (json["data"] as Array<any>).map(LabelFromJSON),
  };
}

export function LabelListResponseToJSON(
  value: LabelListResponse | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value.offset,
    limit: value.limit,
    order: value.order,
    sort: value.sort,
    count: value.count,
    data: (value.data as Array<any>).map(LabelToJSON),
  };
}
